export interface FormalityStatusesJson {
  name: string;
  value: string;
}

export class FormalityStatuses {
  constructor(
    public name?: string,
    public value?: string
  ) {}

  static toJson(formalistStatusesType: FormalityStatuses): FormalityStatusesJson {
    return {
      name: formalistStatusesType.name,
      value: formalistStatusesType.value
    };
  }
}
